'use strict';
/* global google, googleMap */
let map;

function renderMap(el, map_styles) {
  let lat = jQuery(el).data("lat");
  let lng = jQuery(el).data("lng");
  let zoom = jQuery(el).data("zoom");
  let hide_zoom_control = jQuery(el).data("hide-zoom-control");
  let gesture_handling = jQuery(el).data("gesture-handling");
  let hide_default_ui = jQuery(el).data("hide-default-ui");
  let show_marker = jQuery(el).data("show-marker");
  let marker_color = jQuery(el).data("marker-color");

  let lat_float = parseFloat(lat);
  let lng_float = parseFloat(lng);

  map = new google.maps.Map(el, {
    zoom: zoom,
    disableDefaultUI: hide_default_ui === 1,
    center: {lat: lat_float, lng: lng_float},
    styles: map_styles,
    zoomControl: hide_zoom_control === 0,
    gestureHandling: gesture_handling,
  });

  if (show_marker === 1) {
    let marker_svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" ' +
      'fill="' + marker_color + '" stroke="' + marker_color + '" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/>' +
      '<circle cx="12" cy="10" r="3" fill="#FFFFFF" stroke="' + marker_color + '"/></svg>';

    let marker = new window.google.maps.Marker({
      position: {
        lat: lat_float,
        lng: lng_float
      },
      map: map,
      draggable: false,
      lat: lat_float,
      lng: lng_float,
      icon: {
        url: 'data:image/svg+xml;utf8,' + encodeURIComponent(marker_svg),
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(20, 40)
      }
    });

    if (typeof googleMap !== "undefined") {
      googleMap.markers.push(marker);
    }
  }
}

function initMap() {
  // complianz error fix
  if (typeof google === "undefined") {
    return;
  }

  let elements = jQuery(".map-canvas");

  jQuery.each(elements, function (k, el) {
    let map_styling_path = jQuery(el).data("map-styling-path");
    fetch(map_styling_path)
        .then(response => response.json())
        .then(json => renderMap(el, json))
  });
}

(function ($) {
  initMap();

})(jQuery);